import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { Checkbox } from '@microsoft/fast-foundation';
import { ChameleonPrefixedElementMixin } from '../common/mixin';
import { SVG_ALERT_OUTLINED } from '@getgo/chameleon-icons';
export class CheckboxComponent extends ChameleonPrefixedElementMixin(Checkbox, 'checkbox') {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.indeterminate = false;
        this.errIcon = document.createElement(this.tagFor('svg'));
        this.msg = document.createElement(this.tagFor('typography'));
        this.partError = document.createElement('div');
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.errorText) {
            this.appendErrorState();
        }
    }
    checkedChanged(oldValue, newValue) {
        super.checkedChanged(oldValue, newValue);
        this.$emit('input');
    }
    errorTextChanged(oldValue, newValue) {
        if (newValue && oldValue !== newValue) {
            this.appendErrorState();
        }
        else if (this.partError && oldValue !== newValue) {
            this.removeErrorState();
        }
    }
    appendErrorState() {
        if (!this.errorText) {
            return;
        }
        this.classList.add('has-error');
        this.partError.setAttribute('part', 'error');
        this.errIcon.classList.add('error-icon');
        this.errIcon.innerHTML = SVG_ALERT_OUTLINED;
        this.msg.classList.add('error-text');
        this.msg.setAttribute('color', 'type-color-danger');
        this.msg.setAttribute('variant', 'caption-medium');
        this.msg.textContent = this.errorText;
        this.setAttribute('aria-invalid', 'true');
        this.shadowRoot?.appendChild(this.errIcon);
        this.shadowRoot?.appendChild(this.msg);
    }
    removeErrorState() {
        this.classList.remove('has-error');
        this.errIcon.remove();
        this.msg.remove();
        this.removeAttribute('aria-invalid');
    }
}
__decorate([
    attr()
], CheckboxComponent.prototype, "size", void 0);
__decorate([
    attr({ mode: 'boolean' })
], CheckboxComponent.prototype, "disabled", void 0);
__decorate([
    attr({ attribute: 'error-text' })
], CheckboxComponent.prototype, "errorText", void 0);
__decorate([
    attr({ mode: 'boolean' })
], CheckboxComponent.prototype, "indeterminate", void 0);
